/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import MetaForm from 'shared/ui/components/form-components/MetaForm.vue';

// Components

const __vue_script__ = {
    name: 'NestedFormModal',

    components: { MetaForm },

    props: {
        event: {
            type: Object,
            required: true
        },

        label: {
            type: String,
            default: null
        },

        itemValue: {
            type: Object,
            default: () => ({})
        },

        nestedFields: {
            type: Array,
            default: () => []
        },

        editing: {
            type: Number,
            default: null
        },

        save: {
            type: Function,
            default: () => {}
        }
    },

    data() {
        return {
            disabled: false,
            saveHook: 0
        };
    },

    beforeDestroy() {
        this.saveHook = null;
    },

    methods: {
        triggerValidation() {
            this.saveHook = Date.now();
        },

        onValid(value) {
            if (typeof this.save === 'function') {
                this.save(value);
            }

            this.$emit('close');
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-wrapper nested-form-modal"},[(_vm.label)?_c('div',{staticClass:"modal-header"},[_c('a',{staticClass:"close",attrs:{"href":"#"},on:{"click":function () { return _vm.$emit('close'); }}}),_c('h3',[_c('i18n',{attrs:{"path":"generic_form.contextual.nested.title"}},[_c('em',[_vm._v(_vm._s(_vm.label))])])],1)]):_vm._e(),_c('div',{staticClass:"modal-body"},[_c('meta-form',{attrs:{"fields":_vm.nestedFields,"event":_vm.event,"save-hook":_vm.saveHook,"only-validate":true,"edit":Number.isFinite(_vm.editing)},on:{"valid":_vm.onValid},model:{value:(_vm.itemValue),callback:function ($$v) {_vm.itemValue=$$v},expression:"itemValue"}})],1),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.triggerValidation}},[_vm._v(_vm._s(_vm.$t('general.close')))])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "NestedFormModal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__